module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.509074ba.svg";